import React from "react";
import "../styles/sass/main.scss";

const DropDown = (props) => {
  let contents = [];

  props.contents.forEach((content, idx) => {
    let url = '';

    switch (content) {
      case 'AHA':
        url = 'https://www.heart.org/';
        break;
      case 'AAAAI':
        url = 'https://www.aaaai.org/';
        break;
      case 'CPR':
        url = 'https://emedicine.medscape.com/article/1344081-overview';
        break;
      case 'NIH':
        url = 'https://www.nih.gov/';
        break;
      case 'Guidelines for the Diagnosis and Management of Asthma (EPR-3)':
        url = 'https://www.nhlbi.nih.gov/health-topics/guidelines-for-diagnosis-management-of-asthma';
        break;
      case 'International consensus on (ICON) pediatric asthma':
        url = 'https://www.aaaai.org/Aaaai/media/MediaLibrary/PDF%20Documents/About/International-consensus-on-Pediatric-Asthma.pdf';
        break;
      case '2020 AHA Guidelines for CPR':
        url = 'https://www.ahajournals.org/toc/circ/142/16_suppl_2?utm_campaign=sciencenews20-21&utm_source=science-news&utm_medium=phd-link&utm_content=phd10-21-20';
        break;
      default:
        url = '/' + props.title.toLowerCase() + '/' + content.replace(/\s+/g, '_').toLowerCase();
        break;
    }

    if (content == 'BlueBox' || content == 'Asthmagram') {
      contents.push(<a key={idx} href={url} className="dropdown-content__link">{content}</a>);
    } else {
      contents.push(<a key={idx} href={url} className="dropdown-content__link" target="_blank">{content}</a>);
    }
  });

  return (
    <div className="dropdown nav-item">
      <button className="dropdown-btn">{props.title}</button>
      <div className="dropdown-content">{contents}</div>
    </div>
  );
};

export default DropDown;
